import React, {useState} from 'react';

function ProductExptBtn() {
 const [isLoading, setIsLoading] = useState(false);

  const handleExport = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/products/export`, {
        method: 'POST',
        credentials: 'include',
      });
      setIsLoading(false);

      if (!response.ok) {
        throw new Error('Failed to fetch file');
      }

      // Convert response to blob
      const blob = await response.blob();

      // Create URL for download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'products.xlsx'; // filename
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      setIsLoading(false);
      console.error(err);
      alert('Error exporting Excel');
    }
  };

  return (
    <button onClick={handleExport} className="btn btn-primary btn-sm me-4" disabled={isLoading}>
      {isLoading ? "Please wait..": "Export Products"}
    </button>
  );
}

export default ProductExptBtn;
